import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 border-t border-white/5 bg-[#030303] mt-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
              [ 01 // Manifesto ]
            </p>
            <h3 className="font-display text-3xl md:text-4xl text-white leading-tight max-w-xl">
              Turning imaginations into&nbsp;
              <span className="text-[#CCFF00]">reality</span>, one system at a time.
            </h3>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-3 bg-[#CCFF00] text-black px-6 py-3 font-mono text-[11px] uppercase tracking-[0.2em] hover:bg-white transition-colors duration-200"
            >
              Start a project
              <ArrowUpRight size={14} />
            </Link>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
              Navigate
            </p>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/about" className="hover:text-[#CCFF00] transition-colors">About</Link></li>
              <li><Link to="/blog" className="hover:text-[#CCFF00] transition-colors">Blog</Link></li>
              <li><Link to="/team" className="hover:text-[#CCFF00] transition-colors">Team</Link></li>
              <li><Link to="/careers" className="hover:text-[#CCFF00] transition-colors">Careers</Link></li>
              <li><Link to="/contact" className="hover:text-[#CCFF00] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
              Legal
            </p>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/terms" data-testid="footer-link-terms" className="hover:text-[#CCFF00] transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-[#CCFF00] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/refund" data-testid="footer-link-refund" className="hover:text-[#CCFF00] transition-colors">Refund Policy</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
              Studio
            </p>
            <p className="text-sm text-zinc-400 leading-relaxed">
              Imaginepedia Technologies Pvt. Ltd.<br />
              CIN - U82300TR2025PTC014649<br />
              Agartala, Tripura · Remote-first<br />
              contact@imaginepedia.in
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">
            © {new Date().getFullYear()} Imaginepedia Technologies. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">
            v2.0
          </p>
        </div>
      </div>
    </footer>
  );
}
